import React, { useEffect } from "react";
import {
  Document,
  Image,
  Page,
  PDFViewer,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import { Colors } from "../../../assets/Colors";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import LOGO_RKS from "../../../assets/logo/LOGO_RKS.png";
import angkaTerbilang from "@develoka/angka-terbilang-js"; // if using import
const PAGE_HEIGHT = 822; // Change this to your desired page height
const MARGIN = 15; // Adjust as needed

const ROWS_PER_PAGE = Math.floor((PAGE_HEIGHT - 2 * MARGIN) / 20); // Assuming each row is 20 units in height

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  pageBreak: {
    width: "100%",
    height: 0, // Add spacing between pages if needed
    pageBreakAfter: "always",
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
  },
  viewHeader: {
    width: 130,

    marginLeft: 200,
  },
  title_sub: {
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
  },
  header_kepada: {
    fontWeight: "bold",
    fontSize: 12,
  },
  bottom_ttd: {
    marginTop: 50,
    fontWeight: "bold",
    fontSize: 12,
    width: 200,
  },
  bottom_paraf: {
    marginTop: 100,
    fontWeight: "bold",
    fontSize: 12,
    width: 30,
  },

  header_namasupp: {
    fontWeight: "bold",
    fontSize: 12,
    textTransform: "capitalize",
  },
  title_border: {
    borderBottom: 1,
    fontSize: 12,
    textAlign: "center",
  },
  Stitle_border: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: 20,
  },

  header_section: {
    flexDirection: "row",
  },
  header_section_ttd: {
    marginTop: 20,
    pageBreakInside: "avoid",
    flexDirection: "row",
    breakeInside: "avoid",
  },

  header_title: {
    width: 210,
    fontSize: 9,
    textAlign: "justify",
  },
  header_paraf: {
    width: 30,
    fontSize: 9,
    left: 0,
  },

  header_Right: {
    width: 70,
    marginLeft: 105,
    fontSize: 9,
    textAlign: "left",
  },
  header_Rightv: {
    width: 70,
    marginLeft: 133,
    fontSize: 9,
    textAlign: "left",
  },
  header_mark: {
    width: 15,
    fontSize: 9,
    textAlign: "justify",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 9,
    textAlign: "justify",
  },

  table: {
    borderLeftWidth: 1,
    // borderRadius: 5,
    borderStyle: "solid",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  cell: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellSecondary: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 0,
    borderTop: 0,
    borderLeftWidth: 0,
    borderStyle: "solid",
    fontSize: 10,
  },
  cellClosing: {
    display: "flex",
    paddingLeft: 3,
    paddingTop: 2,
    borderWidth: 1,
    borderBottom: 1,
    borderLeftWidth: 0,
    borderTopWidth: 1,
    borderStyle: "solid",
    fontSize: 10,
  },
  paddings: {
    paddingTop: 10,
  },
  logo: {
    width: 200,
    marginBottom: 20,
    marginLeft: 325,
  },
  logottd: {
    height: 50,
    fontWeight: "bold",
    fontSize: 9,
    width: 90,
  },
  stamp: {
    height: 60,
    fontWeight: "bold",
    fontSize: 9,
    width: 60,
    position: "absolute",
    top: 53,
    left: -25,
    zIndex: -1,
  },
  paraf: {
    height: 30,
    fontWeight: "bold",
    fontSize: 9,
    marginLeft: 100,
    width: 30,
  },
});

const combineStyles = (main, override) => {
  let result = { ...main };
  let ov = { ...override };
  if (typeof override === "object") {
    Object.assign(result, ov);
  }
  return result;
};
// Create Document Component
const BlankoPOReturn = (props) => {
  const data = props.data;
  const Headermaker = (props) => (
    <View style={styles.header_section}>
      <Text style={styles.header_title}>{props.nama}</Text>
      <Text style={styles.header_mark}>:</Text>
      <Text style={styles.text}>{props.data}</Text>
    </View>
  );
  const HeaderTableMaker = (props) => {
    let style = { width: props.width + "%", maxWidth: props.width + "%" };
    let style2 = {};
    if (props.closing) style2 = { borderBottom: 1 };
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 2 };
    }
    if (props.colored) {
      style3 = {
        backgroundColor: "grey",
        color: "white",
      };
    }
    return (
      <Text
        style={combineStyles(
          combineStyles(combineStyles(styles.cell, style), style2),
          style3
        )}
      >
        {props.title}
      </Text>
    );
  };
  const SecondaryTableMaker = (props) => {
    let style = { width: props.width + "%" };
    let style2 = {};
    if (props.closing) {
      style2 = { borderBottom: 1 };
    }
    let style3 = {};
    if (props.number) {
      style3 = { textAlign: "right", paddingRight: 2 };
    }

    return (
      <View
        style={combineStyles(
          combineStyles(combineStyles(styles.cellSecondary, style), style2),
          style3
        )}
        fixed
      >
        <Text>{props.title}</Text>
      </View>
    );
  };

  const splitStringByWidth = (inputString, maxWidth) => {
    const MAX_WIDTH = maxWidth;
    const words = inputString.split(" ");
    let currentLine = words[0];
    let result = "";

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const tempLine = `${currentLine} ${word}`;

      if (tempLine.length > MAX_WIDTH) {
        result += currentLine + "\n";
        currentLine = word;
      } else {
        currentLine = tempLine;
      }
    }

    result += currentLine;
    return result;
  };

  const splitStringByWidthv1 = (inputString, maxWidth) => {
    const MAX_WIDTH = maxWidth;
    const words = inputString.split(" ");
    let currentLine = words[0];
    let result = [];

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const tempLine = `${currentLine} ${word}`;

      if (tempLine.length > MAX_WIDTH) {
        result.push(currentLine);
        currentLine = word;
      } else {
        currentLine = tempLine;
      }
    }

    result.push(currentLine);
    return result;
  };

  const Ketentuan = () => {
    return (
      <View style={{ flexDirection: "column", width: 500 }}>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>1. </Text>
          <Text style={styles.text}>
            Purchase order (PO) adalah dokumen resmi pemesanan pembelian atas
            barang/jasa yang dikeluarkan oleh PT. Ranji Karya Sakti sebagai
            pembeli/pengguna jasa, dilengkapi syarat & ketentuan (term &
            condition) dan merupakan kesepakatan bersama antara PT. Ranji Karya
            Sakti sebagai pembeli/pengguna jasa dan supplier sebagai penjual
            barang/pelaksana jasa.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>2. </Text>
          <Text style={styles.text}>
            Para pihak yang menandatangani PO ini terikat dan tunduk pada syarat
            dan ketentuan yang ditetapkan pada PO dan seluruh lampirannya.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>3. </Text>
          <Text style={styles.text}>
            Penjual/pelaksana jasa wajib mengirimkan/menyerahkan kembali PO yang
            telah ditandatanganinya setelah menerima PO dari pembeli/pengguna
            jasa, baik dalam bentuk dokumen asli ataupun dokumen digital
            berbentuk format pdf yang diterima melalui media pengiriman lainnya
            paling lambat 2 (dua) hari kerja sejak PO dikirimkan oleh
            pembeli/pengguna jasa dan dianggap sah berlaku sebagaimana PO asli.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>4. </Text>
          <Text style={styles.text}>
            PO ini tidak dapat dibatalkan oleh penjual/pelaksana jasa tanpa
            persetujuan dari pembeli/pengguna jasa.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>5. </Text>
          <Text style={styles.text}>
            Sesuai butir no. 3 diatas, jika dalam kurun waktu yang telah
            ditentukan, penjual/pelaksana jasa belum mengirim dan menyampaikan
            PO yang telah ditandatangani, maka penjual/pelaksana jasa dianggap
            telah menyetujui, terikat dan tunduk untuk melakukan janji dan
            perbuatan hukum yang diperlukan benar dalam kewenangannya pada
            syarat dan ketentuan yang ditetapkan pada PO dan seluruh
            lampirannya.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>6. </Text>
          <Text style={styles.text}>
            PO ini dinyatakan sah dan berlaku jika telah ditandatangani, baik
            tanda tangan basah maupun tanda tangan digital/elektronik oleh pihak
            pembeli/pengguna jasa.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>7. </Text>
          <Text style={styles.text}>
            Pengiriman barang oleh penjual ke workshop pembeli wajib menunjukkan
            PO yang telah ditandatangani pihak pembeli, surat jalan atau tanda
            terima lainnya.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>8. </Text>
          <Text style={styles.text}>
            Penjual menjamin bahwa barang merupakan barang baru dengan kondisi
            dan kualitas baik, bebas dari cacat termasuk cacat produksi dan
            sesuai standar penerimaan.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>9. </Text>
          <Text style={styles.text}>
            Pembeli dapat menolak barang dalam keadaan tidak sesuai standar
            penerimaan dan penjual dalam waktu 3 (tiga) hari kerja wajib
            memberikan tanggapan dan melakukan pemeriksaan barang atas penolakan
            barang dari pembeli dan menggantikannya paling lambat 14 (empat
            belas) hari kalender dengan barang baru sesuai ketentuan dalam PO
            ini dan atau perjanjian yang dibuat, semua biaya tambahan dan
            kerugian yang timbul menjadi tanggung jawab penjual sepenuhnya.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>10. </Text>
          <Text style={styles.text}>
            Barang dan jasa yang dikirimkan harus sesuai dengan spesifikasi
            sebagaimana tercantum dalam PO ini, tidak melanggar hak kekayaan
            intelektual pihak lain, tidak melanggar undang-undang, tidak dalam
            sengketa, mempunyai kepemilikan yang sah, apabila melanggar
            ketentuan ini maka penjual wajib membayar penalti sebesar 20 (dua
            puluh) kali lipat dari harga barang atau jasa tersebut, dan juga
            penjual bertanggung jawab untuk setiap kerugian dan tuntutan hukum
            yang timbul dari pihak ketiga sehubungan dengan pelanggaran
            tersebut.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>11. </Text>
          <Text style={styles.text}>
            Penjual wajib melengkapi konfirmasi tanggal pengiriman pada PO, jika
            terjadi keterlambatan pengiriman maka penjual dikenakan denda dan
            wajib membayar denda kepada pembeli 1% (satu persen) perhari
            kalender dari nilai PO. Jika denda tersebut melebihi 10% dari nilai
            PO, Pembeli berhak membatalkan PO dan melakukan pembelian kepada
            pihak lain. Selisih harga dan denda wajib dibayarkan Penjual kepada
            Pembeli, termasuk setiap kerugian yang timbul.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>12. </Text>
          <Text style={styles.text}>
            Kecuali karena permintaan Pembeli dan/atau Force Majeure, kegagalan
            Penjual untuk memenuhi PO baik sebagian maupun keseluruhan maka
            Penjual dikenakan penalti sebesar total nilai PO.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>13. </Text>
          <Text style={styles.text}>
            Pembeli berhak untuk menunda pembayaran sampai dengan semua
            ketentuan PO dipenuhi oleh Penjual.
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>14. </Text>
          <Text style={styles.text}>Syarat penagihan adalah :</Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>Invoice</Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>PO yang telah ditandatangani</Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Surat penerimaan barang / surat jalan yang telah ditandatangani
            penerima barang
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Berita Acara Penyelesaian Pekerjaan jika PO Jasa
          </Text>
        </View>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={styles.text}>15. </Text>
          <Text style={styles.text}>
            Pembeli dengan ini menetapkan ketentuan terkait dengan Komitmen
            Etika Bisnis sehubungan dengan PO sebagai berikut :
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>a. </Text>
          <Text style={styles.text}>
            Penjual (pribadi atau perusahaan) dan/atau perwakilannya wajib
            menolak untuk memberi maupun menerima, menawarkan jasa/imbalan
            kepada pegawai, perwakilan dan/atau direktur dari Pihak Pembeli, di
            mana jasa/imbalan berupa komisi, hadiah, bantuan, pinjaman,
            pemberian lain dalam bentuk apapun atau keuntungan tidak sah lainnya
            baik langsung maupun tidak langsung dari PO ini bertujuan baik
            secara langsung maupun tidak langsung untuk membujuk, menyuap atau
            yang mempengaruhi tender/proyek, perjanjian, pengiriman, pemesanan,
            pelaksanaan jasa antara Pihak Penjual dan Pihak Pembeli.
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>b. </Text>
          <Text style={styles.text}>
            Menjaga kerahasiaan informasi barang-barang yang dibeli atau dijual
            atau diberikan kepada Pembeli mencakup mutu, bahan-bahan dan
            formulasi produk yang menurut peraturan serta praktek umum yang
            berlaku di dunia usaha wajib dirahasiakan oleh Penjual, baik selama
            maupun setelah perjanjian berakhir.
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 13 }}
        >
          <Text style={styles.text}>c. </Text>
          <Text style={styles.text}>
            Pelanggaran atas Komitmen Etika Bisnis (KEB), maka kepada Penjual
            dan/atau perusahaan yang diwakilinya dikenakan ketentuan dan sanksi
            sebagai berikut :
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 26 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Membayar kepada Pembeli penalti sebesar 100 (seratus) kali lipat
            dari nilai setiap pemberian yang diberikan
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 26 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Penangguhan pembayaran atas Barang/Jasa, dan/atau
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 26 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Membatalkan atau menangguhkan sebagian atau seluruh PO (surat
            pemesanan) dan/atau
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 26 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Melakukan tindakan hukum yang diperlukan.
          </Text>
        </View>
        <View
          style={{ flexDirection: "row", marginBottom: 4, paddingLeft: 26 }}
        >
          <Text style={styles.text}>- </Text>
          <Text style={styles.text}>
            Sehubungan hal-hal tersebut di atas, Pihak Penjual dan/atau
            perusahaan yang diwakilinya dalam hal ini melepaskan seluruh hak-hak
            untuk melakukan perlawanan hukum dan upaya lainnya serta membebaskan
            Pembeli dari setiap kerugian, tuntutan dalam bentuk apapun.
          </Text>
        </View>
      </View>
    );
  };

  let Total = 0;
  data.Data &&
    data.Data.map((values, id) => {
      Total += parseFloat(values.HargaSatuan) * parseFloat(values.Quantity);
    });
  if (data.DiscPercent != 0) {
    data.DiscRupiah = 0;
  }
  const Discount = parseFloat(
    Total - (Total - (Total * data.DiscPercent) / 100 - data.DiscRupiah)
  );
  const TotalDisc = parseFloat(Total - Discount);
  const PPN = parseFloat((TotalDisc * data.PPN) / 100);
  const PPH = parseFloat((TotalDisc * data.PPH) / 100);
  const PBBKB = parseFloat((TotalDisc * data.PBBKB) / 100);
  // Biaya Lain-lain PC: di LUAR biaya utama, ditambahkan setelah pajak (tak kena PPN/PPH/PBBKB).
  const BiayaLain = Math.max(0, parseFloat(data.BiayaLain) || 0);
  const GTotal = parseFloat(TotalDisc + (PPN - PPH) + PBBKB + BiayaLain);

  // Uang muka dari MSR induk (kosong bila PO ini tanpa DP). Sisa bayar dilantai
  // di 0 supaya DP yang lebih besar dari nilai PO tidak tercetak sebagai negatif
  // di dokumen yang dikirim ke vendor.
  const DP = parseFloat(data.DownpaymentNominal) || 0;
  const SisaBayar = Math.max(GTotal - DP, 0);

  const stringArray = splitStringByWidthv1(
    angkaTerbilang(GTotal.toFixed(0)) + " rupiah",
    70
  );

  let firstString;
  let secondString = "";

  if (stringArray.length === 0) {
    firstString = angkaTerbilang(GTotal) + " rupiah";
  } else {
    firstString = stringArray[0];
    secondString = stringArray[1];
  }

  const sections = [];

  // Split data into sections that fit on a single page
  for (let i = 0; i < data.Data.length; i += ROWS_PER_PAGE) {
    sections.push(data.Data.slice(i, i + ROWS_PER_PAGE));
  }

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <Image style={styles.logo} src={LOGO_RKS} />
        <View style={styles.viewHeader}>
          <Text style={styles.title_border}>PURCHASE ORDER</Text>
        </View>
        <View>
          <Text style={styles.Stitle_border}>{data.PurchaseOrderID}</Text>
        </View>

        <View style={styles.header_section}>
          <Text style={styles.header_title}>{"Kepada : "}</Text>
          <Text style={styles.header_Right}>{"Tgl PO"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>
            {new Date(data.TanggalKirim).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_title}>{data.NamaSupplier}</Text>
          <Text style={styles.header_Right}>{"No. MSR"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.PurchaseRequisitionID}</Text>
        </View>

        <View style={styles.header_section}>
          <Text style={styles.header_title}>{data.Alamat}</Text>
          <Text style={styles.header_Right}>{"Tgl MSR"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>
            {new Date(data.DatePR).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_title}>{data.NamaNegara}</Text>
          <Text style={styles.header_Right}>{"Departemen"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.NamaBagian}</Text>
        </View>

        <View style={styles.header_section}>
          <Text style={styles.header_title}></Text>

          <Text style={styles.header_Right}>{"No. Quotation"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>{data.Quotation}</Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_title}>UP : {data.KontakPerson}</Text>

          <Text style={styles.header_Right}>{"Tgl Quotation"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>
            {new Date(data.TanggalKirim).toLocaleString("en-GB", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })}
          </Text>
        </View>
        <View style={styles.header_section}>
          <Text style={styles.header_title}>TLP: {data.Telepon}</Text>
          <Text style={styles.header_Right}>{"Mata Uang"}</Text>
          <Text style={styles.header_mark}>:</Text>
          <Text style={styles.text}>IDR</Text>
        </View>

        <View style={styles.paddings}></View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <HeaderTableMaker colored={true} width={5} title={"No"} />
            <HeaderTableMaker colored={true} width={67} title={"Nama Barang"} />
            <HeaderTableMaker colored={true} width={10} title={"Jumlah"} />
            <HeaderTableMaker colored={true} width={10} title={"Satuan"} />
            <HeaderTableMaker
              colored={true}
              width={18}
              title={"Harga Satuan"}
            />
            <HeaderTableMaker colored={true} width={20} title={"Nominal"} />
          </View>
        </View>
        {sections.map((section, sectionIndex) => {
          let num = 0;
          if (sectionIndex > 0) {
            num = 39 * sectionIndex;
          }
          return (
            <View style={styles.table}>
              {section &&
                section.map((values, id) => {
                  let closing = false;
                  if (id >= section.length - 1) {
                    closing = true;
                  }
                  let spec = "";
                  if (values.Spec != "-") {
                    spec = " - " + values.Spec;
                  }
                  const newBody = splitStringByWidth(
                    values.BarangID + " - " + values.NamaBarang + spec,
                    50
                  );
                  const isLastRowOnPage =
                    id % ROWS_PER_PAGE === ROWS_PER_PAGE - 1;
                  console.log(isLastRowOnPage, section.length - 1, id, closing);
                  return (
                    <View style={styles.tableRow}>
                      <HeaderTableMaker
                        closing={true}
                        width={5}
                        title={id + 1 + num}
                      />
                      <HeaderTableMaker
                        closing={true}
                        width={67}
                        title={newBody}
                      />
                      <HeaderTableMaker
                        number={true}
                        closing={true}
                        width={10}
                        title={parseFloat(values.Quantity).toLocaleString(
                          "in-ID",
                          { maximumFractionDigits: 0 }
                        )}
                      />
                      <HeaderTableMaker
                        closing={true}
                        width={10}
                        title={values.Satuan}
                      />
                      <HeaderTableMaker
                        number={true}
                        closing={true}
                        width={18}
                        title={parseFloat(values.HargaSatuan).toLocaleString(
                          "in-ID",
                          { maximumFractionDigits: 0 }
                        )}
                      />
                      <HeaderTableMaker
                        number={true}
                        closing={true}
                        width={20}
                        title={(
                          parseFloat(values.HargaSatuan) *
                          parseFloat(values.Quantity)
                        ).toLocaleString("in-ID", { maximumFractionDigits: 0 })}
                      />
                    </View>
                  );
                })}
              <View></View>
            </View>
          );
        })}

        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker
              width={92}
              title={"Terbilang : " + firstString}
            />
            <SecondaryTableMaker width={18} title={"Jumlah"} />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={Total.toLocaleString("in-ID", {
                maximumFractionDigits: 0,
              })}
            />
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} title={secondString} />
            <SecondaryTableMaker
              width={18}
              title={"Diskon " + data.DiscPercent + "%"}
            />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={Discount.toLocaleString("in-ID", {
                maximumFractionDigits: 0,
              })}
            />
          </View>
        </View>

        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} title={""} />
            <SecondaryTableMaker width={18} title={"Total"} />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={TotalDisc.toLocaleString("in-ID", {
                maximumFractionDigits: 0,
              })}
            />
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} title={""} />
            <SecondaryTableMaker width={18} title={"PPN " + data.PPN + "%"} />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={PPN.toLocaleString("in-ID", { maximumFractionDigits: 0 })}
            />
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} title={""} />
            <SecondaryTableMaker width={18} title={"PPh " + data.PPH + "%"} />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={PPH.toLocaleString("in-ID", { maximumFractionDigits: 0 })}
            />
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} title={""} />
            <SecondaryTableMaker
              width={18}
              title={"PBBKB " + data.PBBKB + "%"}
            />
            <SecondaryTableMaker
              number={true}
              width={20}
              title={PBBKB.toLocaleString("in-ID", {
                maximumFractionDigits: 0,
              })}
            />
          </View>
        </View>
        {BiayaLain > 0 ? (
          <View style={styles.table}>
            <View style={[styles.tableRow]}>
              {/* Keterangan Biaya Lain-lain di sel kiri yang lebar, agar tak terpotong. */}
              <SecondaryTableMaker
                width={92}
                title={
                  data.KeteranganBiayaLain
                    ? "Keterangan biaya lain-lain: " + data.KeteranganBiayaLain
                    : ""
                }
              />
              <SecondaryTableMaker width={18} title={"Biaya Lain-lain"} />
              <SecondaryTableMaker
                number={true}
                width={20}
                title={BiayaLain.toLocaleString("in-ID", {
                  maximumFractionDigits: 0,
                })}
              />
            </View>
          </View>
        ) : null}
        <View style={styles.table}>
          <View style={[styles.tableRow]}>
            <SecondaryTableMaker width={92} closing={true} title={""} />
            <SecondaryTableMaker width={18} closing={true} title={"Total "} />
            <SecondaryTableMaker
              number={true}
              closing={true}
              width={20}
              title={GTotal.toLocaleString("in-ID", {
                maximumFractionDigits: 0,
              })}
            />
          </View>
        </View>

        {/* Uang muka yang direferensikan MSR induk PO ini. Baris ini hanya muncul
            bila DP-nya ada dan sudah cair — PO tanpa DP tampil seperti sebelumnya. */}
        {DP > 0 && (
          <View style={styles.table}>
            <View style={[styles.tableRow]}>
              <SecondaryTableMaker width={92} closing={true} title={""} />
              <SecondaryTableMaker
                width={18}
                closing={true}
                title={"Uang Muka "}
              />
              <SecondaryTableMaker
                number={true}
                closing={true}
                width={20}
                title={DP.toLocaleString("in-ID", {
                  maximumFractionDigits: 0,
                })}
              />
            </View>
            <View style={[styles.tableRow]}>
              <SecondaryTableMaker width={92} closing={true} title={""} />
              <SecondaryTableMaker
                width={18}
                closing={true}
                title={"Sisa Bayar "}
              />
              <SecondaryTableMaker
                number={true}
                closing={true}
                width={20}
                title={SisaBayar.toLocaleString("in-ID", {
                  maximumFractionDigits: 0,
                })}
              />
            </View>
          </View>
        )}

        {data.Tipe == "Jasa" ? (
          <>
            <Text style={styles.text}>{"Termin:"}</Text>

            <View style={styles.table}>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`1`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin1}%`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${((data.Termin1 / 100) * GTotal).toLocaleString(
                    "in-ID",
                    { maximumFractionDigits: 0 }
                  )}`}
                />
              </View>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`2`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin2}%`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${((data.Termin2 / 100) * GTotal).toLocaleString(
                    "in-ID",
                    { maximumFractionDigits: 0 }
                  )}`}
                />
              </View>
              <View style={styles.tableRow}>
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`3`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${data.Termin3}%`}
                />
                <HeaderTableMaker
                  number={true}
                  closing={true}
                  width={10}
                  title={`${((data.Termin3 / 100) * GTotal).toLocaleString(
                    "in-ID",
                    { maximumFractionDigits: 0 }
                  )}`}
                />
              </View>

              <View> </View>
            </View>
          </>
        ) : null}

        <Text style={styles.bottom_ttd}>{"Term Of Conditions :"}</Text>
        <Text style={styles.text}>{data.Toc}</Text>

        <View style={styles.header_section}>
          {GTotal >= 10000000 && (
            <View style={styles.header_title}>
              <Text style={styles.bottom_ttd}>{"PT. Ranji Karya Sakti"}</Text>

              <Image style={styles.logottd} src={"/speciment/AldiHarris.png"} />
              <Image style={styles.stamp} src={"/stamp.png"} />
              <Text style={styles.bottom_ttd_name}>{"Aldi Harris"}</Text>
              <Image
                style={styles.paraf}
                src={"/speciment/ArisSugiyanto.jpg"}
              />
            </View>
          )}
          {GTotal < 10000000 && (
            <View style={styles.header_title}>
              <Text style={styles.bottom_ttd}>{"PT. Ranji Karya Sakti"}</Text>

              <Image
                style={styles.logottd}
                src={"/speciment/DessiRiyanti.png"}
              />
              <Image style={styles.stamp} src={"/stamp.png"} />
              <Text style={styles.bottom_ttd_name}>{"Dessi Riyanti"}</Text>
              <Image style={styles.paraf} src={"/speciment/paraf.jpg"} />
            </View>
          )}
          <View style={styles.header_title}>
            <Text style={styles.bottom_ttd}>{"Menyetujui"}</Text>
            <Text style={styles.bottom_ttd}>{"__________________ "}</Text>
          </View>
        </View>

        {/* <View style={styles.header_section_ttd}>
                    <View style={styles.header_title}>

                        <Text style={styles.bottom_ttd}>
                            {"PT. Ranji Karya Sakti "}
                        </Text>
                        <Text style={styles.bottom_ttd}>
                            {"____________________ "}
                        </Text>
                    </View>
                    <View style={styles.header_Right}>

                        <Text style={styles.bottom_ttd}>
                            {"Menyetujui"}
                        </Text>
                        <Text style={styles.bottom_ttd}>
                            {"____________________ "}
                        </Text>

                    </View>
                </View> */}
        <Text style={styles.bottom_ttd}>{"ketentuan :"}</Text>
        <Ketentuan style={styles.bottom_ttd}></Ketentuan>
      </Page>
    </Document>
  );
};

const BlankoPO = () => {
  const params = useParams();
  const mutationGetBlanko = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/mon/" + formData)
  );

  useEffect(() => {
    if (params.id) {
      mutationGetBlanko.mutate(params.id);
    }
  }, []);

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-screen -mt-32">
        {mutationGetBlanko.data && (
          <PDFViewer className={"h-screen w-full"}>
            {<BlankoPOReturn data={mutationGetBlanko.data.data} />}
          </PDFViewer>
        )}
      </div>
    </div>
  );
};
export default BlankoPO;
